"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import _ from "underscore";
import ReactUtils from "../../react_utils";
const bem = ReactUtils.makeBem("load-detail");
function extraReferences(tmsObject) {
  const refs = [];
  _.each(tmsObject.references, (value, name) => {
    refs.push({
      name,
      value
    });
  });
  return refs;
}
function customerLoadDetails(customerLoad2) {
  const references = [];
  extraReferences(customerLoad2).forEach((ref) => {
    references.push(ref);
  });
  const html = _.map(references, function(ref) {
    return /* @__PURE__ */ jsxs(
      "div",
      {
        className: bem("__info-reference-pair"),
        children: [
          /* @__PURE__ */ jsxs("span", { className: bem("__info-reference-name"), children: [
            ref.name,
            ":"
          ] }),
          /* @__PURE__ */ jsx("span", { className: bem("__info-reference-value"), children: ref.value })
        ]
      },
      `customer-load-reference-${ref.name}`
    );
  });
  return /* @__PURE__ */ jsx("div", { children: html });
}
function customerLoad(load, index) {
  const rowClasses = bem({
    "__info-table-data": true,
    even: index % 2 === 0
  });
  return /* @__PURE__ */ jsxs("tr", { className: rowClasses, children: [
    /* @__PURE__ */ jsx("td", { className: bem("__info-with-references"), children: load.customer_load_id }),
    /* @__PURE__ */ jsx("td", { className: bem("__info-with-references"), children: customerLoadDetails(load) })
  ] }, `customer_load_info_${index}`);
}
export default function CustomerLoadsInformation(props) {
  return /* @__PURE__ */ jsx("div", { className: "row", children: /* @__PURE__ */ jsx("div", { className: "small-10 column", children: /* @__PURE__ */ jsxs("table", { className: bem("__info-table", "__info-table-with-references"), children: [
    /* @__PURE__ */ jsx("thead", { children: /* @__PURE__ */ jsxs("tr", { className: bem("__info-table-header"), children: [
      /* @__PURE__ */ jsx("th", { children: "Customer Load Id" }),
      /* @__PURE__ */ jsx("th", { children: "Details" }),
      /* @__PURE__ */ jsx("th", {})
    ] }) }),
    /* @__PURE__ */ jsx("tbody", { children: _.map(props.customerLoads, customerLoad) })
  ] }) }) });
}
